import React from 'react';
import cn from 'clsx';
import { Layout } from 'fronton-react';
import { useStoreon } from 'storeon/react';
import { Banner, RemoteCarousel, RootLayout } from 'common/components';
import { MODEL_JSON_STORE_NAME, modifyBannerImages } from 'modules/model-json';
import { convertProducts } from 'utils';
import { css } from 'linaria';
import { CurrentStories, UspCards } from './components';
import { PROMO_BANNER, PROMO_ELEMENT_BLOCK, PROMO_PATH } from './promo-constants';

const promoFirstBanners = css`
  && {
    margin-bottom: 24px;

    @media (--only-tablet) {
      margin-bottom: 16px;
    }

    @media (--only-mobile) {
      margin-bottom: 12px;
    }
  }
`;

const promoSecondCarousel = css`
  && {
    margin-bottom: 60px;

    @media (--to-desktop) {
      margin-bottom: 44px;
    }

    @media (--only-mobile) {
      margin-bottom: 40px;
    }
  }
`;

/**
 * Вью лендинга Промо
 */
export const Promo = () => {
  const { modelJson } = useStoreon(MODEL_JSON_STORE_NAME);
  const { banners, bannersSecond, offers, stories } = modelJson.model;
  const currentStoriesBanner = modifyBannerImages(stories.banner);

  const isBannersSecond =
    bannersSecond.level0.length !== 0 ||
    bannersSecond.level1.length !== 0 ||
    bannersSecond.level2.length !== 0 ||
    bannersSecond.level3.length !== 0;

  return (
    <RootLayout currentPage={PROMO_PATH}>
      <Layout>
        <UspCards
          className={cn({
            [promoFirstBanners]:
              (isBannersSecond && !offers[1]) || (isBannersSecond && offers[1].products.length === 0),
          })}
          {...banners}
        />
        {offers[1] && offers[1].products.length > 0 && (
          <RemoteCarousel
            className={promoSecondCarousel}
            elementBlock={PROMO_ELEMENT_BLOCK}
            productIdList={convertProducts(offers[1].products)}
            remoteId="otherCarousel"
            seeMoreLink={offers[1].link}
            showSeeMore
            title={offers[1].title}
          />
        )}
        {isBannersSecond && <UspCards {...bannersSecond} />}
        <CurrentStories banner={currentStoriesBanner} currentStoryTitle={stories.title} />
        <RemoteCarousel
          elementBlock={PROMO_ELEMENT_BLOCK}
          productIdList={convertProducts(offers[0].products)}
          remoteId="bestsellersCarousel"
          seeMoreLink={offers[0].link}
          showSeeMore
          title={offers[0].title}
        />
        <Banner {...PROMO_BANNER} />
      </Layout>
    </RootLayout>
  );
};
